const mapStateToProps = state => {
    return {
        callcenterBlacklist: state.blacklistReducer,
    };
};

export { mapStateToProps };
